import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

const ProjectCard = (props) => {
  return (
    <Card
      className="project-card-view"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      <Card.Img
        variant="top"
        src={props.imgPath}
        alt="card-img"
        style={{
          height: "200px",
          objectFit: "contain",
          padding: "10px",
          borderRadius: "20px",
        }}
      />

      <Card.Body
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flexGrow: 1,
        }}
      >
        <div>
          <Card.Title>{props.title}</Card.Title>

          <Card.Text
            style={{
              textAlign: "justify",
              fontSize: "15px",
            }}
          >
            {props.description}
          </Card.Text>
        </div>

        <div
          style={{
            marginTop: "15px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {/* FULL STACK PROJECT */}
          {props.projectType === "fullstack" ? (
            <>
              {props.frontendLink && (
                <Button
                  variant="primary"
                  href={props.frontendLink}
                  target="_blank"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BsGithub /> &nbsp; Frontend Code
                </Button>
              )}

              {props.backendLink && (
                <Button
                  variant="dark"
                  href={props.backendLink}
                  target="_blank"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BsGithub /> &nbsp; Backend Code
                </Button>
              )}
            </>
          ) : (
            <>
              {/* SINGLE PROJECT */}
              {props.frontendLink && (
                <Button
                  variant="primary"
                  href={props.frontendLink}
                  target="_blank"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BsGithub /> &nbsp; Project Code
                </Button>
              )}
            </>
          )}

          {/* DEMO BUTTON */}
          {!props.isBlog && props.demoLink && (
            <Button
              variant="success"
              href={props.demoLink}
              target="_blank"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CgWebsite /> &nbsp; Demo
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProjectCard;
